enum ProjectOrderlineFlexWritebackStatus {
  None = 0,
  InProgress = 1,
  Success = 2,
  Failed = 3,
}
export default ProjectOrderlineFlexWritebackStatus
